// channels
import { useState } from "react";
import { useHistory } from 'react-router-dom';

import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbDividerMedium from "../webx/webb-divider-md";
import WebbLoader from "../webx/webb-loader";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";



export default function SettingsModule () {

  const asset = UserForm() === "in" ? GetLocalUser() : GetLocalBusiness();
  const history = useHistory();
 
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({ });

  if (loading) return <WebbLoader/>


  return (
  <>


  </>

  )
}